import {Component, Input, OnInit} from '@angular/core';
import { MessageType } from '../../../models/request-offer/request-offer.enum';
import { NotificationService } from '../../../../core/services/impl/notification.service';
import { FormControl, Validators } from '@angular/forms';
import { ApplicationStateService } from '../../../services/application-state.service';
import { NotificationStateService } from '../../../services/notification-state.service';
import { MetricsService } from '../../../services/metrics.service';
import { CustomMetricsName } from '../../../components/models/metrics/custom-metrics-name.enum';
import { MetricsType } from '../../../components/models/metrics/metrics-type.enum';
import { AppMode } from '../../../models/app-mode.enum';
import {AssetsService} from '../../../services/assets.service';
import {NotificationState} from '../../../models/notification-state';

@Component({
  selector: 'app-insurer-data-authorization',
  templateUrl: './insurer-data-authorization.component.html',
  styleUrls: ['./insurer-data-authorization.component.scss']
})
export class InsurerDataAuthorizationComponent implements OnInit {

  @Input() notificationState: NotificationState;
  translationComponentKey = 'INSURER_DATA_AUTHORIZATION_MESSAGE';
  smsCodeControl = new FormControl(null, [Validators.required]);

  constructor(private notificationService: NotificationService,
              private assetsService: AssetsService,
              private notificationStateService: NotificationStateService,
              private metricsService: MetricsService,
              private stateService: ApplicationStateService) {
  }

  ngOnInit() {
    this.sendComponentMetric();
  }

  get status(): PaymentAuthorizationStatus {
    return this.notificationState.paymentAuthorizationStatus;
  }

  get imageUrl(): string {
    return this.assetsService.informationDialogImageSrc;
  }

  public cancel() {
    this.sendDecisionMetric(false);
    this.notificationService.sendNotification(MessageType.AUTHORIZATION_ADDRESS_DATA, {
      userDecision: false,
      smsCode: null
    });
    this.stateService.mode = AppMode.NOTIFICATIONS;
  }

  public confirm(): void {
    this.sendDecisionMetric(true);
    this.smsCodeControl.markAsTouched();
    if (this.smsCodeControl.valid) {
      this.notificationService.sendNotification(MessageType.AUTHORIZATION_ADDRESS_DATA, {
        userDecision: true,
        smsCode: this.smsCodeControl.value
      });
      this.stateService.mode = AppMode.NOTIFICATIONS;
    }
  }

  private sendComponentMetric(): void {
    this.notificationStateService.sendNotificationComponentMetric('InsurerDataAuthorizationComponent', { status: this.status });
  }

  private sendDecisionMetric(confirmed: boolean): void {
    const value = confirmed ? 'confirmed' : 'canceled';
    this.metricsService.sendSimpleMetric(CustomMetricsName.INSURER_DATA_AUTHORIZATION, MetricsType.BUTTON, value);
  }
}

export interface PaymentAuthorizationStatus {
  firstName: string;
  lastName: string;
  address: {
    postalCode: string;
    city: string;
    street: string;
    flatNumber?: string;
    buildingNumber?: string;
  }
  code?: number;
  statusCode?: string;
  message?: string;
}
